import { z } from 'zod';
import { FullHiringCopilotDefinition } from 'libs/end-to-end/src/types/databases/copilots/hiring-copilot-definition';
import { HiringCopilotDefinition } from 'libs/end-to-end/src/types/databases/copilots/hiring-copilot-definition';
import { FullPromotionCopilotDefinition } from 'libs/end-to-end/src/types/databases/copilots/promotion-copilot-definition';
import { PromotionCopilotDefinition } from 'libs/end-to-end/src/types/databases/copilots/promotion-copilot-definition';
import { FullPayBenchmarkingCopilotDefinition } from 'libs/end-to-end/src/types/databases/copilots/pay-benchmarking-copilot-definition';
import { PayBenchmarkingCopilotDefinition } from 'libs/end-to-end/src/types/databases/copilots/pay-benchmarking-copilot-definition';
import { FullPayCorrectionCopilotDefinition } from 'libs/end-to-end/src/types/databases/copilots/pay-correction-copilot-definition';
import { PayCorrectionCopilotDefinition } from 'libs/end-to-end/src/types/databases/copilots/pay-correction-copilot-definition';

export const FullCopilotDefinition = z
  .union([
    FullHiringCopilotDefinition,
    FullPromotionCopilotDefinition,
    FullPayBenchmarkingCopilotDefinition,
    FullPayCorrectionCopilotDefinition,
  ])
  .describe('FullCopilotDefinition');

export type FullCopilotDefinition = z.infer<typeof FullCopilotDefinition>;

// We exclude any fields here that are data set references, since they cause a cache miss on the dependency due to the schema changing.
export const CopilotDefinition = z
  .union([
    HiringCopilotDefinition,
    PromotionCopilotDefinition,
    PayBenchmarkingCopilotDefinition,
    PayCorrectionCopilotDefinition,
  ])
  .describe('CopilotDefinition');

export type CopilotDefinition = z.infer<typeof CopilotDefinition>;
